import { NgIf } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'aig-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink, RouterLinkActive],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public authenticated: boolean = false;
  public visibleBtnSesion: boolean = true;
  public btnIsHistory: boolean = false;

  constructor(private router: Router, private authService: AuthService) {
    this.router.events.subscribe(() => {
      if (this.router.url.match('auth')) {
        this.visibleBtnSesion = false;
      }
      if (this.router.url.match('area-cliente')) {
        this.visibleBtnSesion = true;
        this.authenticated = true;
      }
      if (this.router.url.match('area-cliente/historial-polizas') || this.router.url.match('area-cliente/poliza-finalizada')) {
        this.btnIsHistory = true
      }
    });
  }

  ngOnInit() {

  }

  public goToLogin() {
    this.router.navigate(['/auth/login']);
    location.replace('/auth/login');
  }

  public LogOut() {
    this.authService.logout().subscribe(() => {
     this.router.navigate(['/']);
    location.replace('/');
    });
  }

  public goToClientArea() {
    this.router.navigate(['/area-cliente']);
    location.replace('/area-cliente');
  }

  public goToHistoryPolicy() {
    this.router.navigate(['/area-cliente/historial-polizas']);
    location.replace('/area-cliente/historial-polizas');
  }

  public goToClaimManagement() {
    this.router.navigate(['/area-cliente/gestion-siniestros']);
    location.replace('/area-cliente/gestion-siniestros');
  }

  public HistorialPolizas() {
    this.router.navigate(['/area-cliente/historial-polizas']);
    location.replace('/area-cliente/historial-polizas');
  }

  public ActivePolice() {
    this.router.navigate(['/area-cliente']);
    location.replace('/area-cliente');
  }

  ngOnDestroy() {
    this.router.events;
  }
}
